<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';



import 'swiper/css';
import 'swiper/css/pagination';

const props = defineProps({
  related: {
    type: Array,
    default: () => []
  },
  model: Object,
});


const breakpoints = {
  736: {
    slidesPerView: 2,
    spaceBetween: 20
  },
  1216: {
    slidesPerView: 3,
    spaceBetween: 20
  },
};
</script>

<template>
  <div class="slideshow-container-gama">
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :space-between="10"
      :loop="true"
      :breakpoints="breakpoints"
      class="mySwiperUrbanoGamas">
      <swiper-slide v-for="(prod, index) in related" :key="prod.id || index">
        <a :href="prod.slug">
          <div class="slide-card">
            <div class="image-wrapper">
              <img
                v-if="prod.featured_image"
                :src="prod.featured_image.fullUrl"
                :alt="prod.name"
              />
            </div>
            <div class="slide-info">
              <p class="name">{{ prod.name }}
                <span :class="{
                       'navy-color': prod.reference === 'Navy',
                       'mint-color' : prod.reference === 'Mint',
                       'pink-color' : prod.reference === 'Pink',
                       'snow-color' : prod.reference === 'Snow',}">
                  {{ prod.reference }}
                </span>
              </p>
              <p>{{ prod.label_list }}</p>
            </div>
          </div>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<style scoped>

.mySwiperUrbanoGamas{
  width: 75%;
}
</style>
